import useAuthStore from '@/stores/useAuthStore'
import { useMutationGraphQL } from '@/use-graphql'
import { useEffect } from 'react'
import { logoutMutation } from './graphql/mutation'
import { useNavigate } from 'react-router-dom'
import { routes } from '@/routes/utils'
import { usePostHog } from '@posthog/react'
import { capture } from '@/utils/analytics'

const Logout = () => {
  const navigate = useNavigate()
  const posthog = usePostHog()
  const { logout } = useAuthStore()
  const logoutMutate = useMutationGraphQL(
    logoutMutation,
    {},
    {
      onSuccess: () => {
        navigate(routes.requestCode.getPath())
      },
    },
  )

  useEffect(() => {
    capture('user_logged_out')
    // Disable autocapture and recording after logout
    posthog.set_config({ autocapture: false, capture_pageview: false })
    posthog.stopSessionRecording()
    posthog.reset()
    localStorage.setItem('org-type', '')
    logout()
    logoutMutate.mutate()
  }, [])

  return null
}

export default Logout
